export default {
      id: "scale-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#scale",
      toString: function () {
        return this.url;
      }
    }